interface Props {
  title: string
  description?: string
}

export function SettingsPageHeader({ title, description }: Props) {
  return (
    <div>
      <h2 className="text-2xl font-bold text-foreground">{title}</h2>
      {description && <p className="text-muted-foreground">{description}</p>}
    </div>
  )
}
